import { onChangeCreator, updateWithAmountOfWeeks, updateWithWeekday } from 'app/area/company-report/components/schedule-helpers';
import { ScheduleFieldKeys } from 'app/area/company-report/constants';
import * as React from 'react';
import { CheckboxList, ComplexValue, Numberbox } from 'ui';
import styles from './report-screen.scss';

export const WeeklySchedule = ({
  setScheduleDefinition,
  scheduleDefinition,
  scheduleWeekdayOptions,
  translations,
  locale,
  getValidationErrors
}) =>
{
  const scheduleWeekdayOptionsWithTitle: ComplexValue<number>[] = scheduleWeekdayOptions?.map( (o: ComplexValue<number>) => (
    {value: o.value, title: o.description}
  ));
  const onChangeWeekday = onChangeCreator(updateWithWeekday, setScheduleDefinition);
  const onChangeWeeklyAmountOfWeeks = onChangeCreator(updateWithAmountOfWeeks, setScheduleDefinition);
  const { weeksInterval, daysOfWeek } = scheduleDefinition?.recurWeekly;
  const recurWeeklyDaysOfWeekValidationErrors = getValidationErrors(ScheduleFieldKeys.recurWeeklyDaysOfWeek);
const weeksIntervalValidationErrors = getValidationErrors(ScheduleFieldKeys.recurWeeklyWeeksInterval);
  const recurWeeklyDaysOfWeekClass = !!getValidationErrors(ScheduleFieldKeys.recurWeeklyDaysOfWeek) ? styles.hasDanger : '';

return <>
  <div className={`${styles.scheduleRow}`}>
    <div className={styles.textWrapper}>
      <span className={styles.texts}>{translations.recur_every}</span>
    </div>
    <div className={styles.numberbox}>
      <Numberbox
        componentId={ScheduleFieldKeys.recurWeeklyWeeksInterval}
        value={weeksInterval}
        onChange={onChangeWeeklyAmountOfWeeks}
        className={styles.scheduleNumberbox}
        locale={locale}
        validation={weeksIntervalValidationErrors}
        maxValue={999999999}
      />
    </div>
    <div className={styles.textWrapper}>
      <span className={styles.texts}>{translations.weeks_on}</span>
    </div>
  </div>
  <div className={`row ${styles.scheduleRow}`}>
    <div className="col-12">
      <CheckboxList
        componentId={ScheduleFieldKeys.recurWeeklyDaysOfWeek}
        options={scheduleWeekdayOptionsWithTitle}
        className={`${styles.checkboxList} ${recurWeeklyDaysOfWeekClass}`}
        valueItems={daysOfWeek}
        onChange={onChangeWeekday}
        validation={recurWeeklyDaysOfWeekValidationErrors}
      />
    </div>
  </div>
</>;
};
